import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { useDropOffLocationContext } from '../../core/application/contexts'
import { breakpoints } from '../../core/application/theme/breakpoints'
import { CloseIcon } from '../icons'
import NavigationButtons from '../submitDropoff/NavigationButtons'
import {
  getRewardDoneButtonTitle,
  getRewardStepTitle
} from './GetRewardStep'
import GetRewardInfo from './steps/GetRewardInfo'

interface GetRewardDialogProps {
  dropoffId: string
}

const GetRewardDialog: React.FC<GetRewardDialogProps> = ({ dropoffId }) => {
  const intl = useIntl()
  const { setDisplayGetRewardDropoffId } = useDropOffLocationContext()
  const [isLoading] = useState<boolean>(false)
  // QR code image data url

  // Navigation

  const closeDialog = () => {
    setDisplayGetRewardDropoffId(undefined)
  }

  const onExitButtonClick = () => {
    closeDialog()
  }

  const onPreviousClick = () => {
    closeDialog()
  }


  const renderCurrentStep = () => {
    // Step 1
    return (
      <GetRewardInfo
      />
    )
  }

  const renderButtons = () => {
    let nextStepIntl = getRewardDoneButtonTitle()

    return (
      <NavigationButtons
        nextTitle={intl.formatMessage({ id: nextStepIntl })}
        onPreviousClick={onPreviousClick}
        onNextClick={onExitButtonClick}
        isLoading={isLoading}
      />
    )
  }

  return (
    <GetRewardDialogContainer>
      <Header>
        <CloseButton onClick={onExitButtonClick}>
          <CloseIcon />
        </CloseButton>
      </Header>
      <Title>{intl.formatMessage({ id: getRewardStepTitle() })}</Title>
      {renderCurrentStep()}
      {renderButtons()}
    </GetRewardDialogContainer>
  )
}

const GetRewardDialogContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 24px;
  background: ${({ theme }) => theme.color.white};
  box-shadow: 8px 0px 16px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  border-radius: 0px;

  @media ${breakpoints.tablet} {
    width: 60vw;
    max-width: 620px;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
  }
`

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 14px;
  position: relative;

  @media ${breakpoints.tablet} {
    flex-direction: row-reverse;
  }
`

const CloseButton = styled.button`
  cursor: pointer;
  z-index: 5;
`

const Title = styled.div`
  text-align: left;
  font-style: normal;
  font-family: ${({ theme }) => theme.font.semi};
  font-weight: ${({ theme }) => theme.weight.semi};
  font-size: ${({ theme }) => theme.size.big};
  color: ${({ theme }) => theme.color.black};
  margin-bottom: 12px;
`

export default GetRewardDialog
